import { reactive } from "@vue/composition-api";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";

import { ClientField } from "@/store/modules/clientFields";
import { buildFormCommodityAutocomplete } from "@/models/Commodity";
import { buildFormClientAutocomplete } from "@/models/Client";

interface hasClientFieldId {
  client_field_id: string;
}

export interface FormClientField {
  id: string;
  name: string;
  description: string;
  acres: number | string;
  client_id: string;
  commodity_id: string;
  map_url: string;
  formCommodity: AutocompleteResult;
  formClient: AutocompleteResult;
}

export function buildFormClientField() {
  let { formCommodity } = buildFormCommodityAutocomplete();
  let { formClient } = buildFormClientAutocomplete();

  const formClientField = reactive<FormClientField>({
    id: "",
    name: "",
    description: "",
    acres: 0,
    client_id: "",
    commodity_id: "",
    map_url: "",
    formCommodity: formCommodity,
    formClient: formClient,
  });

  const loadClientFieldIntoForm = (cf: ClientField, fcf: FormClientField) => {
    fcf.id = cf.id;
    fcf.description = cf.description;
    fcf.name = cf.name;
    fcf.acres = cf.acres;
    fcf.client_id = cf.client_id;
    fcf.commodity_id = cf.commodity_id;
    fcf.map_url = cf.map_url;

    fcf.formCommodity.label = cf.commodity;
    fcf.formCommodity.id = cf.commodity_id;
    fcf.formClient.id = cf.client_id;
    fcf.formClient.label = cf.client_name;
  };

  return {
    formClientField,
    loadClientFieldIntoForm,
  };
}

export function buildFormClientFieldAutocomplete() {
  let formClientField = reactive<AutocompleteResult>({
    id: "",
    label: "",
  });

  let updateClientField = (
    evt: AutocompleteResult,
    formClientField: AutocompleteResult,
    formData: hasClientFieldId,
  ) => {
    formClientField.id = evt.id;
    formClientField.label = evt.label;
    formData.client_field_id = evt.id;
  };

  return {
    formClientField,
    updateClientField,
  };
}
